// extracted by mini-css-extract-plugin
export default {"modal":"bWyGIlG1w5HH63d6nKFA","titleWrapper":"UYc5GpbS7FUX0ZrQq0t7"};